import React, { useContext, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import productData from "../Datas/productData";
import Footer from "./Footer";
import "../css/productdetails.scss";
import { CartContext } from "../Component/CartContext";
import Header from "./Header";

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = productData.find((item) => item.id === parseInt(id));
  const { addToCart } = useContext(CartContext);

  const [selectedColor, setSelectedColor] = useState(product?.color?.[0] || "");
  const [selectedImage, setSelectedImage] = useState(0);
  const [quantity, setQuantity] = useState(1);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!product) {
    return (
      <div className="product-detail">
        <Header />
        <div className="product-detail__not-found">
          <h2>Product not found</h2>
          <Link onClick={toTop} to="/shop">
            Back to Shop
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  const handleAddToCart = () => {
    // We do not have a size selector in the new UI design, but keeping signature
    addToCart(product.id, quantity, product.size || "N/A", selectedColor);
    navigate("/cartpage");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const setImage = (idx) => {
    setSelectedImage(idx);
  };

  const handleNextImage = () => {
    if (product?.img && product.img.length > 0) {
      setSelectedImage((prev) => (prev + 1) % product.img.length);
    }
  };

  const handlePrevImage = () => {
    if (product?.img && product.img.length > 0) {
      setSelectedImage(
        (prev) => (prev - 1 + product.img.length) % product.img.length
      );
    }
  };

  const increaseQuantity = () => {
    setQuantity((prev) => prev + 1);
  };

  const decreaseQuantity = () => {
    if (quantity > 1) {
      setQuantity((prev) => prev - 1);
    }
  };

  return (
    <div className="product-detail">
      <Header />

      {!product ? (
        <div className="product-detail__not-found">
          <h2>Product not found</h2>
          <Link onClick={toTop} to="/shop">
            Back to Shop
          </Link>
        </div>
      ) : (
        <div className="product-detail__container">
          {/* 面包屑导航 */}
          <nav className="product-detail__breadcrumb">
            <Link onClick={toTop} to="/">
              Home
            </Link>
            <span className="separator">&rsaquo;</span>
            <Link onClick={toTop} to="/shop">
              All Products
            </Link>
            <span className="separator">&rsaquo;</span>
            <Link onClick={toTop} to={`/shop?category=${product.category}`}>
              {product.category}
            </Link>
            <span className="separator">&rsaquo;</span>
            <span className="current">{product.name}</span>
          </nav>

          {/* 主内容区 */}
          <div className="product-detail__main">
            {/* 左侧图片区域 */}
            <div className="product-detail__gallery">
              <div className="product-detail__main-image-wrapper">
                <img
                  src={product.images?.[selectedImage] || ""}
                  alt={product.name}
                  className="product-detail__main-image"
                />
              </div>

              {product.img && product.img.length > 1 && (
                <div className="product-detail__thumbnail-carousel">
                  <button
                    className="carousel-nav-btn prev"
                    onClick={handlePrevImage}
                  >
                    <i className="fa-solid fa-chevron-left"></i>
                  </button>
                  <div className="product-detail__thumbnails">
                    {product.img.map((img, idx) => (
                      <button
                        key={idx}
                        className={`product-detail__thumbnail ${
                          selectedImage === idx ? "active" : ""
                        }`}
                        onClick={() => setImage(idx)}
                      >
                        <img
                          src={img}
                          alt={`${product.name} view ${idx + 1}`}
                        />
                      </button>
                    ))}
                  </div>
                  <button
                    className="carousel-nav-btn next"
                    onClick={handleNextImage}
                  >
                    <i className="fa-solid fa-chevron-right"></i>
                  </button>
                </div>
              )}
            </div>

            {/* 右侧产品信息 */}
            <div className="product-detail__info">
              <div className="brand-tag">Pawluna</div>
              <h1 className="product-detail__name">{product.name}</h1>

              {/* 价格 */}
              <div className="product-detail__price">${product.price}</div>

              {/* 短描述 / 特性列表 */}
              <ul className="product-detail__short-features">
                {product.Features &&
                  product.Features.map((feature, idx) => (
                    <li key={idx}>- {feature}</li>
                  ))}
                {product.description && (
                  <li>
                    -{" "}
                    {Array.isArray(product.description)
                      ? product.description[0].substring(0, 80)
                      : product.description.substring(0, 80)}
                    ...
                  </li>
                )}
              </ul>

              {/* 属性表格 */}
              <div className="product-detail__attributes">
                <div className="attribute-item">
                  <span className="attr-label">MATERIAL</span>
                  <span className="attr-value">
                    {product.material || "Non-toxic food grade rubber (TPR)"}
                  </span>
                </div>
                <div className="attribute-item">
                  <span className="attr-label">SIZE</span>
                  <span className="attr-value">
                    {product.size || "23 x 14 x 1.6 cm"}
                  </span>
                </div>
                <div className="attribute-item">
                  <span className="attr-label">WEIGHT</span>
                  <span className="attr-value">{product.weight || "90 g"}</span>
                </div>
              </div>

              {/* 库存与发货状态 */}
              <div className="product-detail__status">
                <div className="status-item">
                  <i className="fa-solid fa-check check-icon blue-icon"></i>
                  <span>In Stock</span>
                </div>
                <div className="status-item right-align">
                  <i className="fa-solid fa-check check-icon blue-icon"></i>
                  <span>
                    Free Delivery over $40{" "}
                    <span className="subtext">Eligible U.S. orders</span>
                  </span>
                </div>
              </div>

              {/* 颜色选择 */}
              {product.color && product.color.length > 0 && (
                <div className="product-detail__option color-option">
                  <label className="product-detail__label">
                    <span className="req">*</span> Product Colour
                  </label>
                  <div className="product-detail__options color-circles">
                    {product.color.map((colorObj, idx) => (
                      <button
                        key={idx}
                        className={`color-circle-btn ${
                          selectedColor === colorObj.colorName ? "active" : ""
                        }`}
                        onClick={() => setSelectedColor(colorObj.colorName)}
                        title={colorObj.colorName}
                      >
                        <img src={colorObj.img} alt={colorObj.colorName} />
                      </button>
                    ))}
                  </div>
                </div>
              )}

              {/* 添加到购物车控制区 */}
              <div className="product-detail__action-row">
                <div className="quantity-selector">
                  <button onClick={decreaseQuantity}>
                    <i className="fa-solid fa-minus"></i>
                  </button>
                  <span className="qty-number">{quantity}</span>
                  <button onClick={increaseQuantity}>
                    <i className="fa-solid fa-plus"></i>
                  </button>
                </div>
                <button
                  className="product-detail__add-to-cart"
                  onClick={handleAddToCart}
                >
                  Add to Cart
                </button>
              </div>
            </div>
          </div>

          {/* 下方长描述区域 */}
          <div className="product-detail__full-description-card">
            <h2>Description</h2>
            <div className="description-content">
              {product.description &&
                (Array.isArray(product.description)
                  ? product.description.map((paragraph, idx) => (
                      <p key={idx}>{paragraph}</p>
                    ))
                  : product.description
                      .split("\n")
                      .map((paragraph, idx) => <p key={idx}>{paragraph}</p>))}
            </div>
          </div>
        </div>
      )}

      <Footer />
      <button className="back-to-top" onClick={toTop}>
        ↑
      </button>
    </div>
  );
};

export default ProductDetail;
